module.exports = __webpack_public_path__ + "img/RAP3.18bad17b.png";